var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M114.76 88.277h282.48v335.45H114.76z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.721h-105.93V88.273h105.931a8.829 8.829 0 0 1 8.828 8.828v317.792a8.83 8.83 0 0 1-8.829 8.828z",
    fill: "#73af00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.828 88.273h105.931v335.448H8.828A8.829 8.829 0 0 1 0 414.893V97.101a8.829 8.829 0 0 1 8.828-8.828z",
    fill: "#4173cd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#73af00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.886 251.475l28.635 57.271 28.636-57.271-28.636-57.271zM262.843 251.475l28.636 57.271 28.635-57.271-28.635-57.271zM227.364 320.327l28.635 57.27 28.636-57.27-28.636-57.271z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVc);
export default __webpack_public_path__ + "static/media/vc.683d7811386790ef8cd18fdaeb3e2902.svg";
export { ForwardRef as ReactComponent };